import React from 'react';
import PrivacyPolicy from '../PrivacyPolicy'; // Import the actual policy content
import coolyLogo from '../assets/coolyLogo.png'; // Optional: Add logo
import { Link } from 'react-router-dom';
import { ROUTES } from '../App';

const PrivacyPolicyPage = () => {
  return (
    // Add more vertical padding to the outer container
    <div className="min-h-screen bg-[#1E1E2D] text-white p-4 md:py-12 md:px-8">
      {/* Reduced max-width for better line length */}
      <div className="max-w-4xl mx-auto bg-[#2A2A3F] border border-purple-500/30 rounded-lg shadow-lg p-6 md:p-10 lg:p-12">
        <div className="flex justify-center mb-8">
           <Link to={ROUTES.HOME}>
             <img src={coolyLogo} alt="Coooly Logo" className="w-32 h-auto" />
           </Link>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-purple-300 mb-8 text-center">Privacy Policy</h1>
        
        {/* Apply custom styling directly to the container div instead of using prose classes */}
        <div className="text-gray-300">
          <style jsx>{`
            /* Custom injected styles for better spacing */
            .privacy-content h2 {
              color: #d8b4fe;
              font-weight: 600;
              font-size: 1.5rem;
              margin-top: 2.5rem;
              margin-bottom: 1.25rem;
              padding-bottom: 0.5rem;
              border-bottom: 1px solid rgba(139, 92, 246, 0.3);
            }
            
            .privacy-content p {
              margin-bottom: 1.75rem;
              line-height: 1.7;
            }
            
            .privacy-content ul {
              margin-top: 1.5rem;
              margin-bottom: 2rem;
              padding-left: 1.5rem;
              list-style-type: disc;
            }
            
            .privacy-content ul li {
              margin-bottom: 1.5rem;
              padding-left: 0.5rem;
            }
            
            .privacy-content ul li strong {
              color: #ddd6fe;
              font-weight: 600;
            }
            
            .privacy-content a {
              color: #a78bfa;
              text-decoration: underline;
              transition: color 0.15s ease;
            }
            
            .privacy-content a:hover {
              color: #c4b5fd;
            }
          `}</style>
          
          <div className="privacy-content">
            <PrivacyPolicy />
          </div>
        </div>
        
        <div className="mt-12 text-center">
          <Link to={ROUTES.HOME} className="text-purple-400 hover:text-purple-300 underline text-sm">
            &larr; Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
